module.exports = __webpack_public_path__ + "static/media/Nasscom02.7c3eb7ce.jpg";